export default __webpack_public_path__ + "static/duitNow-f0731e2d1dab20dc55cae0042ffe9cda.png";